// extracted by mini-css-extract-plugin
export default {"hamburger":"AdminNavbar_hamburger__ShoMD"};